import { Injectable } from "@angular/core";
import { State } from "@ngxs/store";
import { NotificationState } from "./areas/notification/notification.state";
import { WorkCalendarState } from "./areas/work-calendar/work-calendar.state";


export interface ModulesStateModel { }

// Collection of module specific states
// Add new areas as children
@State<ModulesStateModel>({
    name: 'modules',
    children: [
        NotificationState,
        WorkCalendarState
    ]
})

@Injectable()
export class ModulesState { }